import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDImage,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { ScenarioAcceptContinueButton } from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptCommon/ScenarioAcceptContinueButton';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';

const Layout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr={'title'} {...dataAttrs('select-your-scenario-how-to-title')} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" alignItems={'center'} spacing={3}>
          {resource.withRelationship(fr.relationships.image.name, (rel) => {
            return (
              <FDImage
                width={'100%'}
                alt={'How to image'}
                src={rel.link('related').url()}
                {...dataAttrs('select-your-scenario-how-to-image')}
              />
            );
          }, () => null)}
          <MetaControlField attr={'subtitle'} />
          <MetaControlField attr={'infoMessage'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <ScenarioAcceptContinueButton resource={resource} onClick={onSubmit} />
      </DialogActions>
    </>
  );
};

export default Layout;
